import { atom} from "recoil";

export const networkState = atom<{
  network: string;
}>({
  key: "networkState",
  default: {
    // network: (localStorage.getItem("networkState")!) === null ? "testnet" : (localStorage.getItem("networkState")!),
    network: "testnet"
  },
  dangerouslyAllowMutability: true,
});

